import { CSSProperties, FC } from "react";
import { Col, Row } from "antd";
import { CostAndMarginsChartProps } from "./CostAndMarginsChart";
import { CompanyAnalysisIntelligence } from "../../../../types/IntelligenceTypes";
import { IndustryGrowth } from "./IndustryGrowth";
import { SupplyAndDemand } from "./SupplyAndDemand";
import { EconomicFactors } from "./EconomicFactors";
import { CostAndMargins } from "./CostAndMargins";
import { RegulationAndClient } from "./RegulationAndClient";
import { WorkforceAndTalent } from "./WorkforceAndTalent";

export interface MarketChartsProps extends CostAndMarginsChartProps {
    industryGrowth?: CompanyAnalysisIntelligence["industryGrowth"];
    supplyAndDemand?: CompanyAnalysisIntelligence["supplyAndDemand"];
    economicFactors?: CompanyAnalysisIntelligence["economicFactors"];
    costAndMargins?: CompanyAnalysisIntelligence["costAndMargins"];
    reputation?: CompanyAnalysisIntelligence["reputation"];
    staff?: CompanyAnalysisIntelligence["staff"];
    employees?: number;
    employeeIncrease?: number;
    style?: CSSProperties;
}

export const MarketCharts: FC<MarketChartsProps> = ({
    industryGrowth,
    supplyAndDemand,
    economicFactors,
    costAndMargins,
    reputation,
    staff,
    incomes,
    employees,
    employeeIncrease,
    style,
}) => {
    return (
        <div style={style}>
            <Row gutter={[16, 20]}>
                <Col span={8}>
                    <IndustryGrowth data={industryGrowth} />
                </Col>
                <Col span={8}>
                    <SupplyAndDemand data={supplyAndDemand} />
                </Col>
                <Col span={8}>
                    <EconomicFactors data={economicFactors} />
                </Col>
                <Col span={8}>
                    <CostAndMargins incomes={incomes} data={costAndMargins} />
                </Col>
                <Col span={8}>
                    <RegulationAndClient data={reputation} />
                </Col>
                <Col span={8}>
                    <WorkforceAndTalent
                        data={staff}
                        employees={employees}
                        employeeIncrease={employeeIncrease}
                    />
                </Col>
            </Row>
        </div>
    );
};
